import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/Home/HomePage";
import About from "./components/About/About";
import Layout from "./Layout/Layout";
import CommitPRShareChart from "./components/Reports/developer-distribution/pie/CommitPRShareChart";
import CommitHistoryChart from "./components/Reports/commit/CommitHistoryChart";
import DeveloperCommitsChart from "./components/Reports/commit/DeveloperCommitsChart";
import DeveloperReportsPage from "./components/Reports/developer/DeveloperReportsPage";
import PRHistoryChart from "./components/Reports/pr/PRHistoryChart";
import DeveloperPrChart from "./components/Reports/pr/DeveloperPrChart";
import PowerUsersReports from "./components/Reports/power-users-report/Metabase";
import Configuration from "./components/Configuration/Configuration";
import SignInPage from "./auth/SignInPage";
import WeeklyExceptionReport from "./components/Reports/weekly-exception/WeeklyExceptionReport";
import { useEffect, useState } from "react";
import { authClient } from "./lib/auth-client";

function App() {
  const [signedIn, setSignedIn] = useState(() => {
    return localStorage.getItem("signedIn") === "true";
  });

  //  Better Auth session (
  const { data: session, isPending } = authClient?.useSession();
  console.log("session-");
  console.log("session-");
  console.log("app url ---", process.env.REACT_APP_BASE_URL)
  //  Sync Better Auth session → existing signedIn logic
  useEffect(() => {
    if (session && session != null && !isPending) {
      const loggedInUserDetails = {
        Name : session?.user?.name || "",
        emailId : session?.user?.email || ""
      }
      localStorage.setItem('loggedInUserDetails', JSON.stringify(loggedInUserDetails));
      setSignedIn(true);
      localStorage.setItem("signedIn", "true");
    } else if (!isPending) {
      // session resolved and still null → logged out
      setSignedIn(false);
      localStorage.removeItem("signedIn");
    }
  }, [session, isPending]);

  const handleSignIn = () => {
    // kept for backward compatibility
    setSignedIn(true);
    localStorage.setItem("signedIn", "true");
  };

  const handleSignOut = async () => {
    try {
      await authClient.signOut({
        redirectTo: "/", // frontend login
      });
      localStorage.removeItem("loggedInUserDetails");
      localStorage.removeItem("signedIn");
      setSignedIn(false);
    } catch (err) {
      console.error("Sign out failed", err);
    }
  };

  // Optional: avoid flicker while session is resolving
  if (isPending) return <div>Loading...</div>;

  return (
    <Router>
      {!signedIn && !isPending ? (
        <Routes>
          <Route path="*" element={<SignInPage onSignIn={handleSignIn} />} />
        </Routes>
      ) : (
        <Layout onSignOut={handleSignOut}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/commit-pr-share" element={<CommitPRShareChart />} />
            <Route path="/commit-history" element={<CommitHistoryChart />} />
            <Route path="/pr-history" element={<PRHistoryChart />} />
            <Route path="/developer-reports" element={<DeveloperReportsPage />} />
            <Route path="/commits-reports" element={<DeveloperCommitsChart />} />
            <Route path="/pr-reports" element={<DeveloperPrChart />} />
            <Route path="/power-user-reports" element={<PowerUsersReports />} />
            <Route
              path="/weekly-exception-report"
              element={<WeeklyExceptionReport />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/configuration" element={<Configuration />} />
          </Routes>
        </Layout>
      )}
    </Router>
  );
}

export default App;
